const MapMarkerIcon = () => {
    return (
        <svg
            width="10"
            height="14"
            viewBox="0 0 10 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.64286 6.19648C9.71133 6.04366 9.76906 5.88599 9.81874 5.72468C9.9369 5.34021 10 4.93511 10 4.51668C10 2.02183 7.76181 0 5 0C2.23818 0 0 2.02183 0 4.51668C0 4.93511 0.0631045 5.34021 0.181257 5.72468C0.22825 5.87871 0.284641 6.02911 0.347745 6.17586L0.499463 6.48757L5 14L9.50725 6.47665L9.64286 6.19648ZM9.17159 5.56216C9.12862 5.70164 9.0776 5.83748 9.02793 5.95149L8.91514 6.18799L4.99866 12.7265L1.11305 6.24378L0.97073 5.95391C0.915681 5.82656 0.867347 5.69679 0.825725 5.56337C0.722341 5.22377 0.668635 4.87204 0.668635 4.51789C0.668635 2.36143 2.6101 0.607642 4.99731 0.607642C7.38453 0.607642 9.32599 2.36143 9.32599 4.51789C9.32868 4.87204 9.27631 5.22377 9.17159 5.56216Z"
                fill="currentColor"
            />
            <path
                d="M5.00369 2.48047C3.78188 2.48047 2.79102 3.37556 2.79102 4.47926C2.79102 5.58296 3.78188 6.47804 5.00369 6.47804C6.22549 6.47804 7.21636 5.58296 7.21636 4.47926C7.21502 3.37434 6.22549 2.48047 5.00369 2.48047ZM5.00369 5.8704C4.1538 5.8704 3.46234 5.24578 3.46234 4.47804C3.46234 3.7103 4.1538 3.08568 5.00369 3.08568C5.85358 3.08568 6.54504 3.7103 6.54504 4.47804C6.5437 5.24578 5.85358 5.8704 5.00369 5.8704Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default MapMarkerIcon;
